module.exports = __webpack_public_path__ + "img/Unidad21-5.12284167.png";